import Component from "@glimmer/component"
import styles from "./no-icon-row.module.css"

export default class GoogleClassroomNoIconRowComponent extends Component {
  readonly styles = styles
}
